import type { TranslationTree } from '../../types';

export const modules: TranslationTree = {
  modules: {
    labels: {
      tracabilite: 'Rückverfolgbarkeit',
      analytic: 'Analytik',
      'adaptcut-connector': 'Adaptcut-Connector',
      'machine-learning': 'Maschinelles Lernen',
      labelisation: 'Etikettierung',
      'tool-recommender': 'Werkzeug-Ökodesign',
    },
    descriptions: {
      tracabilite: 'Echtzeit-Verfolgung von Produktionsmeldungen.',
      analytic: 'Erweiterte Statistiken und massgeschneiderte Dashboards.',
      'adaptcut-connector': 'Brücke für Adaptcut-Daten (Odoo) nach ToolLife.',
      'machine-learning': 'Prädiktive Modelle zur Früherkennung von Anomalien.',
      labelisation: 'Bild-Etikettierungssitzungen für das Modelltraining.',
      'tool-recommender': 'Fräswerkzeug-Empfehlungen per genetischem Algorithmus.',
    },
  },
};
